// Purpose: one-line monitored-use notice for external (non-Apogee) flows.
// External users are not gated, but they are monitored (IP/UA captured),
// so they get a persistent notice + link near the primary action.
import { Link } from 'react-router-dom';

export function MonitoredNotice({ className }: { className?: string }) {
  return (
    <p className={['text-body-s text-fg-muted', className ?? ''].join(' ')}>
      Use of this system is monitored and recorded.{' '}
      <Link to="/notice" className="underline hover:text-fg-secondary">
        See privacy &amp; terms
      </Link>
      .
    </p>
  );
}
